
import { Component, Input, OnInit, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, EventEmitter, Output, ViewChild, ElementRef, HostBinding } from '@angular/core';
import { UnicodeService,UnicodeRange } from 'src/app/services/unicode.service';

@Component({
  selector: 'app-unicode-range-selector',
  templateUrl: './unicode-range-selector.component.html',
  styleUrls: ['./unicode-range-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnicodeRangeSelectorComponent implements AfterViewInit {

  private font!: any;
  public unicodeRanges: Array<UnicodeRange> = [];
  constructor(private cdr: ChangeDetectorRef, private unicode: UnicodeService) { }
  ready = new EventEmitter<UnicodeRangeSelectorComponent>();

  @ViewChild('selector') selector!: ElementRef<HTMLSelectElement>;
  @Input() set fontkitFont(font: any) {
    this.fontReady = false;
    this.cdr.detectChanges();
    if (!font) {
      return;
    }
    this.font = font;
    this.unicodeRanges = this.unicode.GetFontRanges(this.font);
    this.fontReady = true;
    this.cdr.detectChanges();
    this.ready.emit(this);
    if (this.unicodeRanges.length > 0) {
      this.rangeChange.emit(this.unicodeRanges[0]);
    }
  }
  @Output() rangeChange = new EventEmitter<UnicodeRange>();
  public fontReady = false;
  ngAfterViewInit(): void {

  }
  SelectByCharacterCode(char:number) {
    let i = 0;
    for(const range of this.unicodeRanges) {
      const [start, end] = range.range;
      if((char >= start) && (char <= end) ) {
        this.selector.nativeElement.selectedIndex = i;
        this.HandleRangeChange()
        break;
      }
      i++;
    }
  }
  HandleRangeChange() {
    if (this.selector) {
      this.rangeChange.emit(this.unicodeRanges[this.selector.nativeElement.selectedIndex]);
    }
  }

}
